import { request } from '../utils/request';

export const fetchRuntimeLogLevelsAPI = () =>
  request.get('/superadmin/runtime-log-level');

export const updateRuntimeLogLevelAPI = body =>
  request.put('/superadmin/runtime-log-level', body);

export const fetchLogLevelAuditAPI = params =>
  request.get('/superadmin/runtime-log-level/audit', { params });
